export default __webpack_public_path__ + "static/media/shape-categories.0d9c1324.svg";